import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import './RefreshDataDialog.css';

interface IRefreshDataDialogProps {
    dialogName: string;
    handleRefreshData?: (refreshType: number) => void;
    hideDialog: () => void;
}

const RefreshDataDialog = (props: IRefreshDataDialogProps) => {

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ExcelFileDialog onCreate()');
    };

    return (
        <Dialog title="Refresh Billing Summary" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '20%' }}>
            <div
                className={'metallic-dialog-body'}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '20px'
                }}
            >
                <Button
                    className={'shiny-metal-button'}
                    style={{ whiteSpace: 'nowrap', width: '75%' }}
                    text={`Refresh Manager's Projects`}
                    onClick={() => props.handleRefreshData(1)}
                />
                <Button
                    className={'shiny-metal-button'}
                    style={{ whiteSpace: 'nowrap', width: '75%' }}
                    text={`Refresh Current Client's Projects`}
                    onClick={() => props.handleRefreshData(1)}
                />
                <Button
                    className={'shiny-metal-button'}
                    style={{ whiteSpace: 'nowrap', width: '75%' }}
                    text={'Refresh Current Project'}
                    onClick={() => props.handleRefreshData(1)}
                />
                <Button
                    className={'shiny-metal-button'}
                    style={{ whiteSpace: 'nowrap', width: '75%' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default RefreshDataDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/RefreshDataDialog.tsx